import { useState } from "react";
import { Upload } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { getSignedUploadUrl, updateBrickCollection } from "../../utils";
import useOrganization from "../../hooks/useOrganization";

const getKey = (organization: string, collection: string, file: any) =>
  `${organization}/${collection}/thumbnail_${file.uid}.${file.name
    .split(".")
    .pop() ?? 'jpg'}`;

interface Props {
  brickCollection: any | null;
  onUpdate(newCollection: any): void;
}

const UploadThumbnail: React.FC<Props> = ({ brickCollection, onUpdate }) => {
  const organization = useOrganization();
  const [loading, setLoading] = useState<boolean>(false);

  const handleFileChanged = async ({ file }: { file: any }) => {
    if (file.status === "removed") {
      await updateBrickCollection(organization, brickCollection._id, {
        thumbnail: null,
      });
      onUpdate({ ...brickCollection, thumbnail: null });
    } else if (file.status === "uploading") {
      setLoading(true);
    } else if (file.status === "done") {
      const thumbnailKey = getKey(organization, brickCollection._id, file);
      const newCollection = await updateBrickCollection(
        organization,
        brickCollection._id,
        {
          thumbnail: thumbnailKey,
        }
      );
      setLoading(false);
      onUpdate(newCollection);
    }
  };

  // Custom xhr upload method
  const handleUpload = async ({
    onSuccess,
    onError,
    onProgress,
    file,
  }: any) => {
    const key = `${organization}/${brickCollection._id}/thumbnail_${
      file.uid
    }.${file.name.split(".").pop() ?? 'jpg'}`;
    const { [key]: signedUrlData } = await getSignedUploadUrl([
      { name: key, contentType: file.type },
    ]);

    const fmData = new FormData();
    Object.keys(signedUrlData.fields).forEach((key) =>
      fmData.append(key, signedUrlData.fields[key])
    );
    fmData.append("file", file);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", signedUrlData.url);
    xhr.onreadystatechange = async () => {
      console.log("done");
      console.log(xhr);
      if (xhr.readyState === 4) {
        if (xhr.status === 204) {
          // Calls the update prop
          // await updatePicture({
          //   variables: { input: { picture: url } },
          // });
          console.log("success");
          onSuccess(null, file);
        } else {
          console.log(xhr.responseText);
          onError(xhr.responseText, xhr.response, file);
        }
      }
    };
    xhr.upload.onprogress = (ev) => {
      onProgress((ev.loaded / ev.total) * 100, file);
    };
    xhr.send(fmData);
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <Upload
      className="thumbnail-uploader"
      accept="image/*"
      listType="picture-card"
      showUploadList={false}
      customRequest={(e) => handleUpload(e)}
      onChange={(e) => handleFileChanged(e)}
    >
      {brickCollection.thumbnail != null ? (
        <img
          src={brickCollection.thumbnail}
          alt="avatar"
          style={{ width: "200px", maxWidth: "100%" }}
        />
      ) : (
        uploadButton
      )}
    </Upload>
  );
};

export default UploadThumbnail;
